import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { pushParams } from 'dpl/actions/query_params';
import { SIGNUP_FORM_TYPES, USER_TYPES } from 'dpl/shared/constants/shared';
import { ANALYTICS_VIEWS } from 'dpl/constants/analytics';

import LoginFormV2 from '../LoginFormV2';
import EmailVerificationFormV2 from '../EmailVerificationForm';

export default function LoginFormWrapper({
  formState,
  formErrors,
  addToFormState,
  handleFormFieldChange,
  hideForgotPassword,
  onPasswordResetClick,
  isFormSubmitting,
  didFormSubmissionFail,
  handleFormSubmission,
  loginOnly,
  enableEmailVerification = true
}) {
  const [verifiedEmail, setVerifiedEmail] = useState(null);
  const dispatch = useDispatch();

  function handleSignupClick(e) {
    e.preventDefault();
    return dispatch(
      pushParams(
        {
          direct_signup: SIGNUP_FORM_TYPES.SIGNUP_INTRO
        },
        { hash: true }
      )
    );
  }

  function handleEmailVerified(email) {
    setVerifiedEmail(email);
    addToFormState('email', email);
  }

  async function handleFormSubmissionWithEmail(payload = {}) {
    const submissionData = {
      ...payload,
      email: verifiedEmail || formState.email
    };
    return handleFormSubmission(submissionData);
  }

  const stateData = {
    user_type: USER_TYPES.BUYER
  };

  return (
    <div className="LoginFormWrapper">
      {enableEmailVerification && !verifiedEmail ? (
        <>
          <EmailVerificationFormV2
            formErrors={formErrors}
            didFormSubmissionFail={didFormSubmissionFail}
            loginOnly={loginOnly}
            onEmailVerified={handleEmailVerified}
            oauthState={stateData}
            headerTitle="Log in"
            analytics={{ view: ANALYTICS_VIEWS.LOG_IN_MODAL }}
          />
          <div className="pt6 mt6 tc bt b--light-gray secondary font-16">
            <p className="font-16 secondary tc">
              First time here?{' '}
              <button
                type="button"
                onClick={handleSignupClick}
                data-test-id="signup_button"
                className="link-button underline stone-700"
              >
                Create an account
              </button>
            </p>
          </div>
        </>
      ) : (
        <LoginFormV2
          formState={{
            ...formState,
            email: verifiedEmail || formState.email
          }}
          formErrors={formErrors}
          addToFormState={addToFormState}
          handleFormFieldChange={handleFormFieldChange}
          hideForgotPassword={hideForgotPassword}
          onPasswordResetClick={onPasswordResetClick}
          isFormSubmitting={isFormSubmitting}
          didFormSubmissionFail={didFormSubmissionFail}
          handleFormSubmission={handleFormSubmissionWithEmail}
        />
      )}
    </div>
  );
}

LoginFormWrapper.propTypes = {
  formState: PropTypes.shape({
    otp_attempt: PropTypes.string,
    otp_channel: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string
  }).isRequired,
  formErrors: PropTypes.object.isRequired,
  addToFormState: PropTypes.func.isRequired,
  handleFormFieldChange: PropTypes.func.isRequired,
  hideForgotPassword: PropTypes.bool,
  onPasswordResetClick: PropTypes.func,
  isFormSubmitting: PropTypes.bool.isRequired,
  didFormSubmissionFail: PropTypes.bool.isRequired,
  handleFormSubmission: PropTypes.func.isRequired,
  loginOnly: PropTypes.bool,
  enableEmailVerification: PropTypes.bool
};

LoginFormWrapper.defaultProps = {
  hideForgotPassword: false,
  onPasswordResetClick: null,
  loginOnly: false,
  enableEmailVerification: true
};
